/**
 * Button Style enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum BUTTON_STYLE {
	DEFAULT = "default",
	CLEAR = "clear",
	TAB = "tab",
	CUSTOM = "custom"
}

export type BUTTON_STYLE_string = keyof typeof BUTTON_STYLE;
